import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enJson from '../../translations/en.json';
const lang = 'en';
const nameSpace = 'common';
i18n.use(initReactI18next).init({
    resources: {},
    lng: lang,
    fallbackLng: lang,
    debug: false,

    /* can have multiple namespace, in case you want to divide a huge translation into smaller pieces and load them on demand */
    ns: [nameSpace],
    defaultNS: nameSpace,
    keySeparator: false,
    interpolation: {
        escapeValue: false,
        formatSeparator: ',',
    },
    react: {
        wait: true,
    },
});
i18n.addResources(lang, nameSpace, enJson);
export default i18n;
